import React, { useEffect, useState } from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

import { EMPTY_STRING, MULTI_SELECT_LIMIT_TAGS } from "../utils/constants";
import { formClasses } from "../styles/AutocompleteStyles";
import { PriorityEnum } from "../utils/Enum.types";
import { useLazyQuery } from "@apollo/client";
import { GetJunctionTypes } from "../components/modules/asset/masters/subsidary/junctions/queries/queries";
import {
  GetJunctionTypesResult,
  GetJunctionTypesVars,
} from "../components/modules/asset/masters/items/queries/types";

import useUrlParams from "../customHooks/useUrlParams";
interface Props {
  onChange: (newValue: string[]) => void;
  autoCompleteValue: string[];
  handleClear: () => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  label?: string;
  placeholder?: string;
}
const MultipleJunctionTypesAutocomplete = ({
  onChange,
  handleClear,
  onKeyDown,
  autoCompleteValue,
  label,
  placeholder,
}: Props) => {
  const { customer_id } = useUrlParams();

  const [options, setOptions] = useState<string[]>([]);

  const [GetJunctionType, { data }] = useLazyQuery<
    GetJunctionTypesResult,
    GetJunctionTypesVars
  >(GetJunctionTypes);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (customer_id)
          GetJunctionType({
            variables: {
              customerID: customer_id,
            },
          }).then(({ data }) => {
            if (data && data.GetJunctionTypes)
              setOptions(data.GetJunctionTypes);
          });
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetJunctionType, customer_id, data]);

  return (
    <>
      <div className="multi-select-autocomplete">
        <Autocomplete
          className={formClasses.inputRoot}
          options={options}
          limitTags={MULTI_SELECT_LIMIT_TAGS}
          multiple
          onChange={(e, newValue) => {
            onChange(newValue);
          }}
          renderOption={(props, option) => {
            const selectedSuppliers = autoCompleteValue.map((value) => value);

            const checked = selectedSuppliers.includes(option as PriorityEnum);

            return (
              <li {...props} key={option as PriorityEnum}>
                <Checkbox style={{ marginRight: 8 }} checked={checked} />
                {option as PriorityEnum}
              </li>
            );
          }}
          onKeyDown={onKeyDown}
          openOnFocus
          forcePopupIcon
          value={autoCompleteValue}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              className={formClasses.formControlRoot}
              label={label}
              slotProps={{
                inputLabel: { shrink: true },
              }}
              placeholder={
                autoCompleteValue.length ? EMPTY_STRING : placeholder
              }
            />
          )}
        />
      </div>

      {/* <LoadingModal flag={loading} /> */}
    </>
  );
};

export default MultipleJunctionTypesAutocomplete;
